<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>

export default {
    name: 'App',
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
    font-size: 14px;
}
html,
body {
    height: 100%;
    overflow: hidden;
}

#app {
    height: 100%;
    width: 100%;
    margin: 0 auto;
    background: #fff;
}

body {
    margin: 0px;
    padding: 0px;
}
</style>
